import { render, staticRenderFns } from "./SystemManagement.vue?vue&type=template&id=f94ff768&scoped=true"
import script from "./SystemManagement.vue?vue&type=script&lang=js"
export * from "./SystemManagement.vue?vue&type=script&lang=js"
import style0 from "./SystemManagement.vue?vue&type=style&index=0&id=f94ff768&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f94ff768",
  null
  
)

export default component.exports